import { Box, Button, TextField, Typography, Link, InputAdornment, IconButton, Stack, ThemeProvider, CssBaseline } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { router } from '@inertiajs/react';
import { useState } from 'react';
import theme from './Theme';
import AuthLayout from './AuthLayout';

export default function Login({ email: initialEmail = '', password: initialPassword = '' }) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState(initialPassword);
  const [error, setError] = useState('');
  const handleLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    fetch('/login', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    }).then((response) => {
      if (response.ok) {
        router.visit('/');
      } else {
        response.json().then((data) => {
          setError(data.error);
        });
      }
    }).catch((error) => {
      setError('Login failed: ' + error);
    });
  };

  return (
    <>
      <AuthLayout title="PrecisionRX | Login">
        <Typography variant="subtitle1" sx={{ textAlign: 'center', color: 'white', mt: {mobile: '0px', tablet_wide: '16px'} }}>
          Delivering more precise, personalized care
        </Typography>
        <Box component="form" sx={{ width: '100%' }}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="email"
            placeholder="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              '& .MuiInputBase-root': { backgroundColor: 'white' },
            }}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            variant="outlined"
            name="password"
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{
              '& .MuiInputBase-root': { backgroundColor: 'white' }
            }}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }}
          />

          {error && <Typography variant="body2" color="error">Email or password is incorrect</Typography>}

          <Box sx={{ display: 'flex', justifyContent: 'flex-starts', mt: 1, mb: 2 }}>
            <Link href={`/reset-password-request?email=${email}`} variant="body2" sx={{ color: 'white' }}>
              Forgot password?
            </Link>
          </Box>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            color="primary"
            sx={{ mt: 2,
              borderRadius: '4px',
              '&:disabled': { backgroundColor: theme.pandia.indigo_light }
            }}
            disabled={!email || !password}
            onClick={handleLogin}
          >
            Log in
          </Button>
        </Box>
      </AuthLayout>
    </>
  );
}
